module.exports = __webpack_public_path__ + "static/full-day-section-bubble-4-6298d8d8a88fdebfe8c07386ba1001c7.png";